import { environment } from '../../../environments/environment.development';
import { PaymentType } from '../interfaces/paymentType.interface';
import {
  PlaceOrderObj,
  POChoices,
  POMenuItem,
} from '../interfaces/placeOrderMenu.interface';
import { MenuCategory, MenuItem } from '../interfaces/restaurantMenu.interface';

export class PlaceOrderCalculation {
  private getLocalStorageData() {
    const storedData = sessionStorage.getItem(
      `sharedData@${environment.appName}`
    );
    if (storedData) {
      return JSON.parse(storedData); // Return the parsed data
    }
    return null;
  }

  // =======================================================================================
  //   This Method calculate Single MenuItem Price Base On menuVariation , Choices (if have)
  //   Get One Param
  //    pass New Item (or you Can just Pase any Item in Cart )and Calculate Price
  // =======================================================================================

  calSingleItemPrice(
    newMenuItem: POMenuItem,
    orderTypeId: number | undefined
  ): string {
    let totalPrice: number = 0;
    if (newMenuItem.order_detail_choice.length > 0) {
      newMenuItem.order_detail_choice.map((choice: POChoices) => {
        totalPrice += parseFloat(choice.price);
      });
    }
    if (newMenuItem.menu_variation && newMenuItem.menu_variation.id) {
      totalPrice += parseFloat(newMenuItem.menu_variation.price);
    } else {
      let menuItem: MenuItem | null = this.getMenuItemFromLocalStorage(
        newMenuItem.menu_id
      );

      if (menuItem) {
        let price = this.changePriceBaseOnOrderType(
          menuItem,
          orderTypeId ?? 2,
          ''
        );
                totalPrice += parseFloat(price);
      } else {
        totalPrice += parseFloat(newMenuItem.price);
      }
    }

    return totalPrice.toFixed(2);
  }

  getMenuItemFromLocalStorage(menuId: number) {
    let localStorageData = this.getLocalStorageData();

    let filterMenu: MenuItem | null = null;
    if (localStorageData && localStorageData.restaurantMenu) {
      let categoryList: MenuCategory[] = localStorageData.restaurantMenu;

      for (const category of categoryList) {
        for (const menu of category.menu) {
          if (menu.id === menuId) {
            filterMenu = menu;
            break;
          }
        }
        if (filterMenu) break;
      }
    }

    return filterMenu;
  }

  /** =======================================================================================
  //   This Method triger Multiple Method And Calculate SubTotal , Total , TaxPrice  , SubTotalWithOutPrice , Discount
  //   Get One Param (Whole PlaceOrder Object)
  //   At the End After All Calculation Return PlaceOrderObj with updated Price
  // =======================================================================================
   */

  calculateDiscount(total: any, disc_per: any) {

    

    const x = (disc_per / 100) * total;
    return x;
  }

  calWholeOrderTotal(placeOrderObj: PlaceOrderObj): PlaceOrderObj {
    let subTotal: number = 0;
    let total: number = 0;
    subTotal = this.calSubTotal(placeOrderObj.order_details);
    let { taxPrice, priceWithOutTax, tax_percent } = this.calTaxPrice(
      subTotal,
      placeOrderObj.payment_type_id
    );
    total = this.calTotal(
      priceWithOutTax,
      taxPrice,
      parseFloat(
        placeOrderObj.discount_amount ? placeOrderObj.discount_amount : '0'
      ), // Adding Discount Amount
      parseFloat(
        placeOrderObj.service_charge ? placeOrderObj.service_charge : '0'
      ),
      parseFloat(
        placeOrderObj.delivery_charge ? placeOrderObj.delivery_charge : '0'
      )
    );
    placeOrderObj = {
      ...placeOrderObj,
      sub_total: Math.round(subTotal).toFixed(2),
      tax_amount: taxPrice.toFixed(2),
      tax_percent: tax_percent.toFixed(2),
      total: Math.round(total).toFixed(2),
    };
    return placeOrderObj;
  }

  calSubTotal(menuItems: POMenuItem[]): number {
    let cal: number = 0;
    if (menuItems.length > 0) {
      menuItems.map((item: POMenuItem) => {
        cal += parseFloat(item.price) * item.quantity;
      });
    }
    return cal;
  }

  calTaxPrice(
    subTotal: number,
    paymentType: number
  ): { taxPrice: number; priceWithOutTax: number; tax_percent: number } {
    let localStorageData = this.getLocalStorageData();
    let taxInclude: boolean = localStorageData?.user?.tax_include;
    let cash_tax_persent = parseFloat(localStorageData?.user?.tax_percent);
    let card_tax_percent = parseFloat(localStorageData.user.card_tax_percent)
      ? parseFloat(localStorageData.user.card_tax_percent)
      : 0;
    let tax_percent: number = 0;
    let taxPrice: number = 0;
    let priceWithOutTax: number = 0;

    if (paymentType === 2) {
      tax_percent = card_tax_percent;
    } else {
      tax_percent = cash_tax_persent;
    }

    switch (taxInclude) {
      case true:
        priceWithOutTax = subTotal / (1 + cash_tax_persent / 100);
        taxPrice = (priceWithOutTax * tax_percent) / 100;

        break;
      case false:
        priceWithOutTax = subTotal;
        taxPrice = (subTotal * tax_percent) / 100;
        break;
      default:
        break;
    }

    return { taxPrice, priceWithOutTax, tax_percent };
  }

  calTotal(
    priceWithOutTax: number,
    tax_amount: number,
    discount_amount: number,
    service_charge: number,
    delivery_charge: number
  ): number {
    return (
      priceWithOutTax -
      discount_amount +
      tax_amount +
      service_charge +
      delivery_charge
    );
  }

  changePriceBaseOnOrderType(
    data: any,
    orderTypeId: number,
    callFrom: string
  ): string {
    switch (orderTypeId) {
      case 3:
        return parseFloat(data.delivery_price) >= 0
          ? data.delivery_price
          : data.price;
      case 2:
        return parseFloat(data.take_away_price) >= 0
          ? data.take_away_price
          : data.price;

      case 1:
        return data.price ? data.price : '0.00';

      default:
        return data.price;
    }
  }

  getPaymentTypeById(paymentType: number): PaymentType {
    let paymentTypeList: PaymentType[] = [
      {
        id: 1,
        type: 'Cash',
        description: 'Cash On Delivery',
      },
      {
        id: 2,
        type: 'Card',
        description: 'Debit or Credit Card',
      },
      {
        id: 3,
        type: 'Easy Paisa',
        description: 'Easy Paisa',
      },
      {
        id: 4,
        type: 'Jazz Cash',
        description: 'Jazz Cash',
      },
      {
        id: 5,
        type: 'MOP',
        description: 'Card and cash payment',
      },
      {
        id: 6,
        type: 'Credit',
        description: 'Credit Payments',
      },
      {
        id: 7,
        type: 'Partial',
        description: 'Paid and credit payments',
      },
    ];

    return (
      paymentTypeList.find(
        (payment: PaymentType) => payment.id === paymentType
      ) ?? paymentTypeList[0]
    );
  }
}
